var exports = {
  "kL": "MessageUploadProgress.module__container___U1JJZG",
  "zc": "MessageUploadProgress.module__iconContainer___U1JJZG",
  "Qs": "MessageUploadProgress.module__content___U1JJZG",
  "Md": "MessageUploadProgress.module__fileName___U1JJZG",
  "Ov": "MessageUploadProgress.module__fileSize___U1JJZG",
  "L$": "MessageUploadProgress.module__progressContainer___U1JJZG",
  "Ik": "MessageUploadProgress.module__progressBarIndeterminate___U1JJZG",
  "U6": "MessageUploadProgress.module__pulse___U1JJZG",
  "hr": "MessageUploadProgress.module__progressBar___U1JJZG",
  "E$": "MessageUploadProgress.module__progressBarNormal___U1JJZG",
  "cs": "MessageUploadProgress.module__progressBarFailed___U1JJZG",
  "x7": "MessageUploadProgress.module__cancelButton___U1JJZG",
};

module.exports = exports;
